import { AfterViewInit, Component, ElementRef, Input, NgZone, OnDestroy, OnInit, ViewChild } from "@angular/core";
declare let $: any;

@Component({
  selector: "review-mail",
  styleUrls: ['./review-mail.component.scss'],
  templateUrl: "./review-mail.component.html",
})

export class ReviewMailComponent implements AfterViewInit {
  @Input() content;
  @Input() width;
  @ViewChild('iframe') iframe: ElementRef;

  ngAfterViewInit() {
    let content = this.content;
    let doc =  this.iframe.nativeElement.contentDocument || this.iframe.nativeElement.contentWindow;
    doc.open();
    doc.write(content);
    doc.close();
  }
}
